import { createStore } from '@stencil/store';
import {
  disableScrollBody,
  enableScrollBody
} from '../../../../../apps/website-frontend/src/ts/helpers/body-scroll.helper';

interface WelcomeModalStore {
  isSuccess: boolean,
  isModalShown: boolean,
  email: string,
}

const { state, set, get, onChange } = createStore<WelcomeModalStore>({
  isSuccess: null,
  isModalShown: null,
  email: null,
});

onChange('isModalShown', value => {
  if (value) {
    disableScrollBody();
  } else {
    enableScrollBody();
    localStorage.setItem('isWelcomeModalClosed', 'true');
  }
});

export { state, set, get };
